// (A) 중립 Pagination API — antd 미접촉. (B) PlainPagination 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainPagination } from '../_impl/PlainPagination'

export interface OmwPaginationProps {
  current?: number
  total?: number
  pageSize?: number
  onChange?: (page: number, pageSize: number) => void
  /** 실측: 페이지 크기 선택 노출 여부. antd 의 아이콘/옵션 세부는 pageSizeOptions 로 중립화. */
  showSizeChanger?: boolean
  pageSizeOptions?: number[]
  /** 실측(ThreadList): 페이지 크기 변경 콜백(antd showSizeChanger 객체형 onChange 중립화). */
  onPageSizeChange?: (pageSize: number) => void
  /** 실측(ThreadList): 크기 선택 드롭다운의 커스텀 화살표 아이콘. */
  sizeChangerSuffixIcon?: ReactNode
  className?: string
  style?: CSSProperties
}

export function OmwPagination(props: OmwPaginationProps) {
  return <PlainPagination {...props} />
}
